import moment from "moment";
import { amountFormat } from "../services/common.service";
import { Button, Empty, Table } from "antd";
import { useTranslation } from "react-i18next";
import { ReactComponent as DownloadIcon } from "../assests/icons/download.svg";

export default function UploadHistoryGrid({
  handleSingleRcordDownload,
  dataSource = [],
  setDetails,
  setVisible,
}) {
  const { t } = useTranslation();
  return (
    <>
      <Table
        rowHoverable={false}
        dataSource={dataSource}
        rowClassName={(record, index) =>
          index % 2 === 0 ? "table-row-light" : "table-row-dark"
        }
        tableLayout="fixed"
        pagination={{
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "30", "40", "50", "100", "500"],
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} records`,
        }}
        bordered
        sticky={true}
        onRow={(record) => ({
          className: "table-row-pointer",
          onClick: () => {
            setDetails(record);
            setVisible(true);
          },
        })}
        columns={[
          {
            title: "File Name",
            align: "left",
            key: "file",
            ellipsis: true,

            render: (option) => (
              <>
                <span
                  className="d-flex align-items-center justify-content-between cursor-pointer"
                  // onClick={(e) => {
                  //   e.stopPropagation();
                  //   e.preventDefault();
                  //   handleSingleRcordDownload(option);
                  // }}
                >
                  <span
                    className="pay-now-text"
                    style={{
                      textDecoration: "underline",
                      whiteSpace: "break-spaces",
                      wordBreak: "break-all",
                    }}
                  >
                    {option.file || "-"}{" "}
                  </span>
                  <span>
                    {option.file !== "null" ? <DownloadIcon height={15} 
                    onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    handleSingleRcordDownload(option);
                  }}/> : ""}
                  </span>
                </span>
              </>
            ),
          },
          {
            title: "Process Name",
            dataIndex: "processName",
            align: "left",
            width: 220,
            key: "processName",
            ellipsis: true,
          },

          {
            title: "Source Account",
            dataIndex: "srcAccNo",
            align: "left",
            width: 210,
            key: "srcAccNo",
            ellipsis: true,
          },
          {
            title: "Value Date",
            align: "left",
            key: "valueDate",
            width: 190,
            ellipsis: true,
            render: (option) => (
              <>
                <span> {(option?.valueDate && option?.valueDate) || "-"}</span>
              </>
            ),
          },

          {
            title: "Status",
            key: "status",
            dataIndex: "status",
            width: 150,
            align: "left",
          },
        ]}
      />
    </>
  );
}
